import {Provider} from "@angular/core";
import {TEST_MODULE_REGISTRY, TestModuleDefinition} from "../../../core/shared/test/data/test-harness.types";
import {
    EmbeddedArtefactsComponent
} from "../component/protected-components/embedded-artefacts/embedded-artefacts.component";
import {TeArtefactObjectComponent} from "../component/protected-components/te-artefact/te-artefact-object.component";
import {
    TeArtefactObjectSideComponent
} from "../component/protected-components/te-artefact/view/te-artefact-object-side/te-artefact-object-side.component";
import {
    TeArtefactObjectFullComponent
} from "../component/protected-components/te-artefact/view/te-artefact-object-full/te-artefact-object-full.component";
import {
    CodeMirrorEditorComponent
} from "../component/protected-components/te-editor/components/code-mirror-editor/code-mirror-editor.component";
import {
    TableInfoConditionsComponent
} from "../component/protected-components/te-editor/components/table-info-conditions/table-info-conditions.component";
import {TeEditorComponent} from "../component/protected-components/te-editor/te-editor.component";
import {TeTemplateObjectComponent} from "../component/protected-components/te-template/te-template-object.component";
import {
    TeTemplateObjectSideComponent
} from "../component/protected-components/te-template/view/te-template-object-side/te-template-object-side.component";
import {
    TeTemplateObjectFullComponent
} from "../component/protected-components/te-template/view/te-template-object-full/te-template-object-full.component";
import {TeTestCaseComponent} from "../component/protected-components/te-test-case/te-test-case.component";
import {
    TeTestCaseSetupComponent
} from "../component/protected-components/te-test-case-setup/te-test-case-setup.component";
import {TeVariablesComponent} from "../component/protected-components/te-variables/te-variables.component";
import {
    TeVariableDialogComponent
} from "../component/protected-components/te-variables-dialog/te-variables-dialog.component";

const teModduleEntry: TestModuleDefinition = {
    key: 'te',
    label: 'Template (te)',
    components: [
        {
            key: 'EmbeddedArtefactsComponent',
            component: EmbeddedArtefactsComponent,
            selector: 'mvs-embedded-artefacts',
            label: 'Embedded Artefacts',
            type: 'Component'
        },
        {
            key: 'TeArtefactObjectComponent',
            component: TeArtefactObjectComponent,
            selector: 'mvs-te-artefact-object',
            label: 'Artefact Object Component',
            type: 'ObjectBaseComponent'
        },
        {
            key: 'TeArtefactObjectSideComponent',
            component: TeArtefactObjectSideComponent,
            selector: 'te-artefact-object-side',
            label: 'Artefact Object Side',
            type: 'Component'
        },
        {
            key: 'TeArtefactObjectFullComponent',
            component: TeArtefactObjectFullComponent,
            selector: 'te-artefact-object-full',
            label: 'Artefact Object Full',
            type: 'Component'
        },
        {
            key: 'CodeMirrorEditorComponent',
            component: CodeMirrorEditorComponent,
            selector: 'code-mirror-editor',
            label: 'CodeMirror Editor',
            type: 'Component'
        },
        {
            key: 'TableInfoConditionsComponent',
            component: TableInfoConditionsComponent,
            selector: 'te-table-info-conditions',
            label: 'TableInfo Conditions',
            type: 'Component'
        },
        {
            key: 'TeEditorComponent',
            component: TeEditorComponent,
            selector: 'mvs-te-editor',
            label: 'Te Editor',
            type: 'Component'
        },
        {
            key: 'TeTemplateObjectComponent',
            component: TeTemplateObjectComponent,
            selector: 'mvs-te-template-object',
            label: 'Te Template Object',
            type: 'ObjectBaseComponent'
        },
        {
            key: 'TeTemplateObjectSideComponent',
            component: TeTemplateObjectSideComponent,
            selector: 'te-template-object-side',
            label: 'Te Template Side',
            type: 'Component'
        },
        {
            key: 'TeTemplateObjectFullComponent',
            component: TeTemplateObjectFullComponent,
            selector: 'te-template-object-full',
            label: 'Te Template Full',
            type: 'Component'
        },
        {
            key: 'TeTestCaseComponent',
            component: TeTestCaseComponent,
            selector: 'mvs-te-test-case',
            label: 'Te Test Case',
            type: 'Component'
        },
        {
            key: 'TeTestCaseSetupComponent',
            component: TeTestCaseSetupComponent,
            selector: 'mvs-te-test-case-setup',
            label: 'Te Test Case Setup',
            type: 'Component'
        },
        {
            key: 'TeVariablesComponent',
            component: TeVariablesComponent,
            selector: 'mvs-te-variables',
            label: 'Te Variables',
            type: 'Component'
        },
        {
            key: 'TeVariableDialogComponent',
            component: TeVariableDialogComponent,
            selector: 'mvs-te-variable-dialog',
            label: 'Te Variable Dialog',
            type: 'Component'
        }

    ]
}

export const TE_TEST_PROVIDERS: Provider[] = [
    {
        provide: TEST_MODULE_REGISTRY, useValue: teModduleEntry, multi: true
    }
]